<template>
  <div class="wrap">
    <div class="d-flex">
      <div class="mr-auto">
        <filter-component
          :list="filterList"
          :values="filters"
          @apply="onFiltersApply"
          class="flex-grow-0 flex-shrink-0 mb-2"
        >
          <template v-slot:buttons>
            <button class="btn btn-secondary ml-1" @click="refresh">
              <i class="fas fa-sync-alt" v-bind:class="{'fa-spin': isRefreshing}"></i>
            </button>
            <button class="btn btn-secondary ml-1" @click="onDownload" v-if="canDownload" :disabled="isRefreshing">
              <i class="fas fa-file-export"></i>
            </button>
          </template>
        </filter-component>
      </div>
      <div class="align-self-end">
        <input-debounced
          v-model="search"
          :clearable="true"
          :autofocus="true"
          placeholder="Search"
          class="search-bar w-300 mb-2"
        ></input-debounced>
      </div>
    </div>
    <base-table
      :base-url="getUrlWithFilters"
      ref="baseTable"
      @load-success="onLoadSuccess"
      @refresh="onRefresh"
      :current-page="currentPage"
      v-loading="isRefreshing"
      element-loading-spinner="el-icon-loading"
    >
      <template v-slot>
        <el-table
          :data="items"
          stripe
          class="w-100"
        >
          <el-table-column
            prop="model.id"
            label="Id"
            min-width="50"
          ></el-table-column>
          <el-table-column
            prop="model.name"
            label="Representative"
            min-width="80"
          ></el-table-column>
          <el-table-column
            prop="model.brand.title"
            label="Brand"
            min-width="80"
          ></el-table-column>
          <el-table-column
            prop="total_reg_messages"
            label="Total email messages"
            min-width="100"
          ></el-table-column>
        </el-table>
      </template>
    </base-table>
    <el-pagination
      layout="prev, pager, next"
      :total="total"
      :current-page.sync="currentPage"
      :page-size="pageSize"
      class="text-right"
    ></el-pagination>
  </div>
</template>

<script>
import TableWithPagination from '../../table-with-pagination';
import {addQueryParams} from '../../../libs/url';
import UrlFilterService from '../../../services/url-filter-service';
import Filter from "../../filter/v1/index-table";
import Download from "../../../mixins/download";

export default {
  extends: TableWithPagination,

  components: {
    FilterComponent: Filter,
  },

  props: {
    filterList: Array,
    downloadUrl: String,
    canDownload: Boolean,
  },

  data() {
    return {
      urlWithFilters: this.url,
      search: null,
      filters: {},
      urlService: null,
    };
  },

  computed: {
    /**
     * @return {string}
     */
    getUrlWithFilters() {
      return addQueryParams(this.url, this.filters);
    },
  },

  watch: {
    search: function (value) {
      this.filters = value
        ? _.assign({}, this.filters, {search: value})
        : this.filters = _.omit(this.filters, ['search']);
    },
  },

  methods: {
    /**
     * @return {undefined}
     */
    initializeFilters() {
      const filterNames = _.map(this.filterList, item => item.name);
      this.urlService = new UrlFilterService(filterNames);
      this.filters = this.urlService.getFilters();
    },

    /**
     * @return {undefined}
     */
    refresh() {
      this.$refs.baseTable.refresh();
    },

    /**
     * @return {undefined}
     */
    applyFilters() {
      this.urlWithFilters = this.urlService.updateUrl(this.filters);
    },

    /**
     * @param {Object} value
     */
    onFiltersApply(value) {
      this.filters = _.assign({}, value);
      this.applyFilters();
    },

    /**
     * @return {undefined}
     */
    onDownload() {
      this.download(_.assign({}, this.filters, {url: this.downloadUrl}));
    },
  },

  created() {
    this.initializeFilters();
  },

  mixins: [
    Download,
  ],
}
</script>
